import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlatformHealthDashboardComponent } from './platform-health-dashboard/platform-health-dashboard.component';

const routes: Routes = [
    {
        path: 'platformHealth',
        children: [
            { path: '', component: PlatformHealthDashboardComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PlatformHealthRoutingModule { }
